<template>
  <div class="liu">
    <!-- 标题 -->
    <mt-header fixed :title="title" class="title2 border-b">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
      <mt-button slot="right" v-show="submitVisible" @click="onPayRiskSubmitClick">{{ submitBtnName }}</mt-button>
    </mt-header>
    <!-- 内容 -->
    <div class="scroll-container">
      <!-- 相机组件 -->
      <camera ref="camera" @getImgInfo="onGetImgInfoHandle" />
      <!-- 页面主体 -->
      <div class="pay-risk-management">
        <!-- 主页 -->
        <div class="detail">
          <!-- 审核结果 -->
          <div class="table" v-show="examineVisible">
            <div class="row">
              <div class="label">
                <span>审核时间</span>
              </div>
              <div class="text">
                <span>{{ myDetailData.auditDate }}</span>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span>审核状态</span>
              </div>
              <div class="text">
                <span>{{ myDetailData.status | chs }}</span>
              </div>
            </div>
            <div class="text-row" v-show="reasonVisible">
              <div class="label">
                <span>失败原因</span>
              </div>
              <div class="value">
                <span>{{ myDetailData.auditMsg }}</span>
              </div>
            </div>
          </div>
          <!-- 申诉理由 -->
          <div class="table mt">
            <div class="row">
              <div class="label">
                <span>商户申诉人姓名</span>
              </div>
              <div class="text">
                <span>{{ myDetailData.name }}</span>
              </div>
            </div>
            <div class="row">
              <div class="label">
                <span>商户申诉人电话</span>
              </div>
              <div class="text">
                <span>{{ myDetailData.mobile }}</span>
              </div>
            </div>
            <div class="text-row" v-if="isDisabled">
              <div class="label">
                <span>申诉理由</span>
              </div>
              <div class="value">
                <span>{{ myDetailData.content }}</span>
              </div>
            </div>
            <div class="text-row" v-else>
              <div class="label">
                <span>申诉理由</span>
              </div>
              <div class="text">
                <textarea row="2" cols="23" v-model="myDetailData.content" placeholder="请输入申诉理由"
                  :disabled="isDisabled" />
              </div>
            </div>
          </div>
          <!-- 上传照片 -->
          <div class="table mt">
            <!-- 店铺门头照 -->
            <div class="high-row">
              <div class="label">
                <span>店铺门头照</span>
              </div>
              <div v-if="isDisabled">
                <img :src="uploadHeader.webUrl || defaultImgUrl" />
              </div>
              <div v-else @click="onUploadHeaderClick">
                <img :src="uploadHeader.webUrl || defaultImgUrl" />
              </div>
            </div>
            <!-- 收银台照片 -->
            <div class="high-row">
              <div class="label">
                <span>收银台照片</span>
              </div>
              <div v-if="isDisabled">
                <img :src="uploadCashier.webUrl || defaultImgUrl" />
              </div>
              <div v-else @click="onUploadCashierClick">
                <img :src="uploadCashier.webUrl || defaultImgUrl" />
              </div>
            </div>
            <!-- 店内照片 -->
            <div class="high-row">
              <div class="label">
                <span>店内照片</span>
              </div>
              <div v-if="isDisabled">
                <img :src="uploadIndoor.webUrl || defaultImgUrl" />
              </div>
              <div v-else @click="onUploadIndoorClick">
                <img :src="uploadIndoor.webUrl || defaultImgUrl" />
              </div>
            </div>
            <!-- 交易凭证 -->
            <div class="high-row">
              <div class="label">
                <span>交易凭证</span>
                <br />
                <span class="tips">(交易流水小票、发票或清单)</span>
              </div>
              <div v-if="isDisabled">
                <img :src="uploadCertificate.webUrl || defaultImgUrl" />
              </div>
              <div v-else @click="onUploadCertificateClick">
                <img :src="uploadCertificate.webUrl || defaultImgUrl" />
              </div>
            </div>
          </div>
        </div>
        <!-- 弹出框 -->
        <mt-popup class="tips-pop" v-model="popupVisible" popup-transition="popup-fade">
          <div class="title">
            <span>示例图片</span>
          </div>
          <div class="image">
            <img :src="popupImgUrl" alt="" />
          </div>
          <div class="link" @click="$refs.camera.imgClick(popupImgObjName)">
            <span>开始拍照</span>
          </div>
          <div class="btn" @click="popupVisible = false">
            <span>取消</span>
          </div>
        </mt-popup>
      </div>
    </div>
  </div>
</template>
<script>
import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { upLoadImg } from '@/utils/utils.js';
import { GetPayTagRiskAuditDetail, UpdatePayTagRisk } from '@/api/user';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
import camera from '@/components/camera.vue';
export default {
  name: 'PayRiskManagementDetail',
  components: { camera },
  data() {
    return {
      id: '',
      title: '',
      status: null,
      myDetailData: {},
      popupImgUrl: null,
      defaultImgUrl: require('@/assets/risk_img_default@3x.png'),
      popupImgObjName: null,
      submitVisible: false, // 控制提交按钮是否显示的开关变量
      examineVisible: false, // 控制审核结果是否显示的开关变量
      reasonVisible: false, // 控制失败原因是否显示的开关变量
      popupVisible: false, // 控制弹框是否显示的开关变量
      isDisabled: false, // 控制是否允许输入的开关变量
      submitBtnName: '提交',
      upLoadImgInfo: {
        headerObjName: 'uploadHeader',
        headerDefaultImg: require('@/assets/risk_img_header@3x.png'),
        cashierObjName: 'uploadCashier',
        cashierDefaultImg: require('@/assets/risk_img_cashier@3x.png'),
        indoorObjName: 'uploadIndoor',
        indoorDefaultImg: require('@/assets/risk_img_indoor@3x.png'),
        certificateObjName: 'uploadCertificate',
        certificateDefaultImg: require('@/assets/risk_img_certificate@3x.png'),
      },
      // 店铺门头照
      uploadHeader: {
        type: '',
        fileUrl: '',
        webUrl: '',
        base64: '',
      },
      // 收银台照片
      uploadCashier: {
        type: '',
        fileUrl: '',
        webUrl: '',
        base64: '',
      },
      // 店内照片
      uploadIndoor: {
        type: '',
        fileUrl: '',
        webUrl: '',
        base64: '',
      },
      // 交易凭证
      uploadCertificate: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initData();
    });
  },
  methods: {
    // 加载数据
    initData() {
      // 滚动条置顶
      window.scrollTo(0, 0);
      // 列表清空
      this.myDetailData = [];
      // 设置状态
      this.setStatus();
      // 加载数据
      this.getMyData();
    },
    // 设置状态
    setStatus() {
      this.id = this.$route.query.id;
      this.status = this.$route.query.status;
      switch (this.status) {
        case '0':
          this.title = '提交解锁材料';
          this.submitBtnName = '提交';
          this.submitVisible = true;
          this.examineVisible = false;
          this.reasonVisible = false;
          this.isDisabled = false;
          break;
        case '1':
          this.title = '待审核详情';
          this.submitBtnName = '提交';
          this.submitVisible = false;
          this.examineVisible = false;
          this.reasonVisible = false;
          this.isDisabled = true;
          break;
        case '2':
          this.title = '审核详情';
          this.submitBtnName = '提交';
          this.submitVisible = false;
          this.examineVisible = true;
          this.reasonVisible = false;
          this.isDisabled = true;
          break;
        case '3':
          this.title = '审核详情';
          this.submitBtnName = '重新解锁';
          this.submitVisible = true;
          this.examineVisible = true;
          this.reasonVisible = true;
          this.isDisabled = true;
          break;
        default:
          this.title = '提交解锁材料';
          break;
      }
    },
    // 获取代理商详情
    getMyData() {
      Indicator.open();
      GetPayTagRiskAuditDetail({ payTagRiskId: this.id })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myDetailData = res.data;
            this.myDetailData.content = res.data.content || '';
            this.uploadHeader.webUrl = this.myDetailData.storeHeaderImgUrl;
            this.uploadCashier.webUrl = this.myDetailData.storeCashierImgUrl;
            this.uploadIndoor.webUrl = this.myDetailData.storeIndoorImgUrl;
            this.uploadCertificate.webUrl = this.myDetailData.orderCertificateUrl;
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
          this.$router.go(-1);
        });
    },
    // 返回的图片信息
    onGetImgInfoHandle(info) {
      this[info.type] = info;
      upLoadImg(
        info.blob,
        info.base64,
        info.type,
        this.myDetailData.mobile,
        yes => {
          if (yes.code === 0) {
            this[info.type].webUrl = yes.data;
            this.popupVisible = false;
          } else {
            this.resetCameraInfo(info.type);
          }
        },
        no => {
          this.resetCameraInfo(info.type);
        }
      );
    },
    // 提交按钮点击事件
    onPayRiskSubmitClick() {
      if (this.submitBtnName === '重新解锁') {
        this.title = '提交解锁材料';
        this.submitBtnName = '提交';
        this.examineVisible = false;
        this.isDisabled = false;
      } else {
        // 验证
        if (!this.myDetailData.content.trim()) {
          CusToast('申诉理由不能为空');
          return;
        }
        if (!this.uploadHeader.webUrl) {
          CusToast('必须上传店铺门头照');
          return;
        }
        if (!this.uploadCashier.webUrl) {
          CusToast('必须上传收银台照片');
          return;
        }
        if (!this.uploadIndoor.webUrl) {
          CusToast('必须上传店内照片');
          return;
        }
        if (!this.uploadCertificate.webUrl) {
          CusToast('必须上传交易凭证');
          return;
        }
        // 提交
        Indicator.open();
        const data = {
          content: this.myDetailData.content.trim(),
          orderCertificateUrl: this.uploadCertificate.webUrl,
          payTagRiskId: parseInt(this.id),
          storeCashierImgUrl: this.uploadCashier.webUrl,
          storeHeaderImgUrl: this.uploadHeader.webUrl,
          storeIndoorImgUrl: this.uploadIndoor.webUrl,
        };
        UpdatePayTagRisk(data)
          .then(res => {
            Indicator.close();
            const msg = SucceedHandle(res.code, res.msg, () => CusToast('提交成功'));
            msg && CusToast(msg);
            this.$router.go(-1);
          })
          .catch(err => {
            Indicator.close();
            const msg = NotSucceedHandle(err.message);
            msg && CusToast(msg);
          });
      }
    },
    // 重新拍照
    resetCameraInfo(name, staus = 1) {
      this[name].fileUrl = '';
      this[name].webUrl = '';
      this[name].base64 = '';
    },
    // 店铺门头照的单击事件
    onUploadHeaderClick() {
      this.popupImgUrl = this.upLoadImgInfo.headerDefaultImg;
      this.popupImgObjName = this.upLoadImgInfo.headerObjName;
      this.popupVisible = true;
    },
    // 收银台照片的单击事件
    onUploadCashierClick() {
      this.popupImgUrl = this.upLoadImgInfo.cashierDefaultImg;
      this.popupImgObjName = this.upLoadImgInfo.cashierObjName;
      this.popupVisible = true;
    },
    // 店内照片的单击事件
    onUploadIndoorClick() {
      this.popupImgUrl = this.upLoadImgInfo.indoorDefaultImg;
      this.popupImgObjName = this.upLoadImgInfo.indoorObjName;
      this.popupVisible = true;
    },
    // 交易凭证的单击事件
    onUploadCertificateClick() {
      this.popupImgUrl = this.upLoadImgInfo.certificateDefaultImg;
      this.popupImgObjName = this.upLoadImgInfo.certificateObjName;
      this.popupVisible = true;
    },
  },
  filters: {
    chs(val) {
      if (val === 0) return '未提交';
      if (val === 1) return '待审核';
      if (val === 2) return '审核成功';
      if (val === 3) return '审核失败';
    },
  },
};
</script>
